import styled from '@emotion/styled';

export const StyledViewContainer = styled('div', {
  shouldForwardProp: property => property !== 'bannersOffset',
})<{ bannersOffset: number }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: ${({ bannersOffset }) => `calc(24px + ${bannersOffset}px)`} 24px 0;
  width: 100%;
  height: 100%;
`;
